import { RemoteData } from '@sbt-web/ancillary-services';
import {
  AdTypes,
  CategoryID,
  type AdItem,
  GeoEntry,
  HebeCampaignPosition,
} from '@sbt-web/network/types';
import { HADES_PATH } from '@/shared/constants';
import type { FiltersStore } from '@/tools/search/getFiltersStore';
import {
  parseAdDetailFeaturesForHebe,
  parseListingFiltersForHebe,
} from '@/tools/search/hebeFiltersParser';

export const prepareRemoteDataAdDetail = (
  position: HebeCampaignPosition,
  item: AdItem,
  isMobile: boolean
): RemoteData => ({
  baseUrl: HADES_PATH,
  body: {
    touchpoint: {
      page: 'AD_DETAIL',
      position,
    },
    metadata: {
      ad_type: item.type.key,
      advertiser_id: item.advertiser?.userId,
      categories: [item.category.id],
      geo: {
        region: item.geo?.region?.id,
        city: item.geo?.city?.id,
        town: item.geo?.town?.id,
      },
      keywords: item.subject,
      property: isMobile ? 'm-site' : 'web',
    },
    filters: parseAdDetailFeaturesForHebe(item),
  },
});

export const prepareRemoteDataListing = (
  position: HebeCampaignPosition,
  ad_type: AdTypes,
  category: CategoryID,
  geo: GeoEntry,
  filters: Record<string, string>,
  query: string,
  isMobile: boolean,
  filterStore: FiltersStore | null
): RemoteData => ({
  baseUrl: HADES_PATH,
  body: {
    touchpoint: {
      page: 'LISTING',
      position,
    },
    metadata: {
      ad_type,
      categories: [category],
      geo: {
        ...(geo?.region?.id !== '0' && { region: geo?.region?.id }),
        city: geo?.city?.id,
        town: geo?.town?.id,
      },
      keywords: query,
      property: isMobile ? 'm-site' : 'web',
    },
    filters: parseListingFiltersForHebe(
      category,
      ad_type,
      filters,
      filterStore
    ),
  },
});
